import React from 'react';
import dayjs from 'dayjs';

import { ButtonIcon } from '../../icons/Icon';

import { EntryContainer } from './EntryContainer';
import { ReminderType } from './useGetRecruitmentReminders';

type ReminderEntryProps = {
  reminder: ReminderType;
};

export const ReminderEntry: React.FC<ReminderEntryProps> = ({ reminder }) => {
  const reminderDate = dayjs.unix(reminder.date).format('YYYY-MM-DD HH:mm');
  const header =
    reminder.type === 'SLACK' ? (
      <>
        <ButtonIcon name="SlackLogo" />
        Slack reminder will perform on {reminderDate}
      </>
    ) : (
      `Email reminder will perform on ${reminderDate}`
    );

  return (
    <EntryContainer date={reminder.date} header={<div>{header}</div>}>
      <div>Title: {reminder.title}</div>
      <div>Note: {reminder.text}</div>
    </EntryContainer>
  );
};
